import { eventBus } from '../app';

export default {
    delimiters: ['${', '}'],
    template: '#modal-upload-images-template',
    props: {
    },

    data() {
        return {
            fileCount: 0,
            show: false
        }
    },

    created() {
        document.addEventListener('keyup', (event) => {
            if (event.keyCode == 27) {
                this.toggleModal();
            }
        });

        eventBus.$on('upload-images', this.openModal);
    },

    mounted() {
    },

    beforeDestroy() {
        eventBus.$off('upload-images', this.openModal);
    },

    methods: {
        filesChanged(event) {
            console.log(arguments);
            this.fileCount = event.target.files.length
        },

        close() {
            this.show = false;
        },

        toggleModal() {
            this.show = !this.show;
        },

        openModal() {
            this.show = true;
        }
    }
};
